// src/services/Fornecedor/FornecedorService.js
import axios from "axios";

const API = "http://localhost:3040";

const FornecedorService = {
  saveFornecedor: async (fornecedor, idRede) => {
    const response = await axios.post(`${API}/fornecedores`, fornecedor, {
      headers: { "x-id-rede": idRede },
    });
    return response.data;
  },

  getFornecedores: async (idRede) => {
    const response = await axios.get(`${API}/fornecedores`, {
      headers: { "x-id-rede": idRede },
    });
    return response.data;
  }
};

export default FornecedorService;
